export const ACTIVITY_SCROLLER_ID = "activity-panel-scroller";
export const COMMENT_HIGHLIGHT_CLASS = "comment-highlight";
